import { ROUTES } from '@/common/constants/routes';
import { useAuth } from '@/common/contexts/authentication/AuthProvider';
import { InsuranceProvider } from '@/common/contexts/insurance/InsuranceContext';
import { UserDetailsProvider } from '@/common/contexts/user/UserDetailsProvider';
import { MobileExperienceModal } from '@/web/components/MobileExperienceModal/MobileExperienceModal';
import { colors } from '@coverflex-tech/hypernova-design-tokens';
import { PortalHost } from '@rn-primitives/portal';
import { Redirect, Stack } from 'expo-router';

export default function DashboardRootLayout() {
  const { user, needsLogin } = useAuth();

  if (!user) {
    return <Redirect href={ROUTES.SIGNIN} />;
  }

  if (needsLogin) {
    return <Redirect href={ROUTES.SOFT_LOGIN} />;
  }

  return (
    <UserDetailsProvider user={user}>
      <InsuranceProvider>
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: {
              backgroundColor: colors.light.semantic.surface.neutral20,
            },
          }}
        />
        <PortalHost name="overlay" />
        <MobileExperienceModal />
      </InsuranceProvider>
    </UserDetailsProvider>
  );
}
